module.exports = __webpack_public_path__ + "img/page2.181671ef.jpg";